"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1({ index, control, isFeeFree, defaultName, defaultPrice, onCustomNameBlur, onCustomPriceBlur, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { field: { onChange: onCustomNameChange, value: customNameValue }, } = (0, react_hook_form_1.useController)({
        name: `custom_name_${index}`,
        control,
        rules: {
            required: t('배송유형을 입력해주세요'),
            pattern: { value: /^[^,]+$/, message: `${t('콤마 (,)를 제거해주세요')}.` },
        },
        shouldUnregister: true,
        defaultValue: defaultName,
    });
    return ((0, jsx_runtime_1.jsxs)(CustomCalcDiv, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "CustomCalcDiv_div" }, { children: (0, jsx_runtime_1.jsx)("input", { name: `custom_name_${index}`, className: "custom_name_input", maxLength: 15, value: customNameValue, onChange: e => onCustomNameChange(e.target.value), onBlur: e => onCustomNameBlur(e.target.value.replace(/,/g, '')), placeholder: "\uC608) \uC6B0\uCCB4\uAD6D\uD0DD\uBC30", autoComplete: "off" }, `custom_name_${defaultName}_${index}`) })), (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { name: `custom_price_${index}`, control: control, defaultValue: defaultPrice, onBlurFunc: onCustomPriceBlur, isFeeFree: isFeeFree, isDelivery: true }, `custom_price_${defaultPrice}_${index}`)] }));
}
exports.default = default_1;
const CustomCalcDiv = styled_1.default.div `
  display: grid;
  grid-template-columns: 0.5fr 0.5fr;
  column-gap: 8px;
  .custom_name_input {
    width: 100%;
    height: 40px;
    padding: 0 13px;
    border: 1px solid var(--gray-10);
    border-radius: 8px;
    font-size: 15px;
    color: var(--gray-80);
    :focus {
      border: 1px solid var(--gray-80);
    }
  }
`;
